const stringCompare = (a, b) => {
  if (a > b) { return 1; }
  if (b > a) { return -1; }
  return 0;
};

export default (itemA, itemB) => {
  const prefixKey = stringCompare(itemA.prefixDecimal, itemB.prefixDecimal);

  if (prefixKey !== 0) {
    return prefixKey;
  }

  const abbrStatementCompare = stringCompare(itemA.abbreviatedStatement, itemB.abbreviatedStatement);

  if (abbrStatementCompare !== 0) {
    return abbrStatementCompare;
  }

  const fullStatementCompare = stringCompare(itemA.fullStatement, itemB.fullStatement);

  if (fullStatementCompare !== 0) {
    return fullStatementCompare;
  }

  return stringCompare(itemA.id, itemB.id);
};
